module.exports = __webpack_public_path__ + "img/chat-ai-assistant-active.7ec8e9e4.svg";